module.exports = {"es-PY":{"errors":{"invalid":"no es válido","missing":"no puede quedar en blanco","taken":"ya está en uso"}}}